



















import { Component, Prop, Vue } from 'vue-property-decorator'
import TextInput from '../TextInput/index.vue';


@Component({
  name: "InputOTP",
  components: {
    TextInput
  }
})
export default class InputOTP extends Vue {
  @Prop({default: 3, type: Number}) public size!: number;
  @Prop({default: "", type: String}) public value!: string;

  get modelValue(): string[] {
    if (this.value) {
      const newValue = this.value.substring(0, this.size);
      if (!isNaN(+newValue)) return newValue.split("");
      return [];
    }

    return [];
  }

  set modelValue(value: string[]) {
    this.$emit("input", value.join(""));
  }

  public onInput(event: InputEvent | number, index = 0): void {
    let value = "";
    if (typeof event === "number") value = event.toString() || "";
    else if (event instanceof InputEvent) value = (event.target as HTMLInputElement).value;
    else value = "";
    if (value.length <= 1) this.modelValue[index] = value;
    this.modelValue = this.modelValue.filter((o) => !!o);
    if (event instanceof InputEvent && event.inputType === "deleteContentBackward") {
      this.moveToPrev(event);
    } else if (
      event instanceof InputEvent &&
      (
        event.inputType === "insertText" ||
        event.inputType === "deleteContentForward"
      )
    ) {
      this.moveToNext(event);
    }
  }

  findNextInput(element: Element): HTMLInputElement | undefined {
    const nextElement =
      element.parentElement?.nextElementSibling?.querySelector("input")

    if (!nextElement) return;
    return nextElement.nodeName === "INPUT"
      ? nextElement
      : this.findNextInput(nextElement);
  }

  findPrevInput(element: Element): HTMLInputElement | undefined {
    const prevElement =
      element.parentElement?.previousElementSibling?.querySelector("input")

    if (!prevElement) return;
    return prevElement.nodeName === "INPUT"
      ? prevElement
      : this.findPrevInput(prevElement);
  }

  moveToPrev(event: InputEvent | KeyboardEvent): void {
    const prevInput = this.findPrevInput(event.target as HTMLInputElement);
    if (prevInput) {
      prevInput.focus();
      prevInput.select();
    }
  }

  moveToNext(event: InputEvent | KeyboardEvent): void {
    const nextInput: HTMLInputElement = this.findNextInput(event.target as HTMLInputElement) as HTMLInputElement;
    if (nextInput) {
      nextInput.focus();
      nextInput.select();
    }
  }

  public onKeyDown(event: KeyboardEvent): void {
    if (event.ctrlKey || event.metaKey) {
      return;
    }

    switch (event.code) {
      case "ArrowLeft":
        this.moveToPrev(event);
        event.preventDefault();

        break;

      case "ArrowUp":
      case "ArrowDown":
        event.preventDefault();

        break;

      case "Backspace":
        if ((event.target as HTMLInputElement).value.length === 0) {
          this.moveToPrev(event);
          event.preventDefault();
        }

        break;

      case "ArrowRight":
        this.moveToNext(event);
        event.preventDefault();

        break;

      case "NumpadEnter":
      case "Tab":
        break;

      case "Enter":
        this.$emit("enter");
        break;

      default:
        if (
          !(
            event.code !== "Space" &&
            Number(event.key) >= 0 &&
            Number(event.key) <= 9
          ) ||
          (this.modelValue.join("").length >= 6 && event.code !== "Delete")
        ) {
          event.preventDefault();
        }

        break;
    }
  }

  public onPaste(event: ClipboardEvent): void {
    const paste = (event.clipboardData as DataTransfer).getData("text");

    if (paste.length) {
      const pastedCode = paste.substring(0, 6);

      if (!isNaN(+pastedCode)) {
        this.modelValue = pastedCode.split("");
      }
    }

    event.preventDefault();
  }
}
